import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

class CheckboxChange extends React.Component {

  state = {
    checkBox: []
  }




  render() {
    return (
      <div>
        
      </div>
    );
  }
}

export default CheckboxChange;
